'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'Embedded Tweets',

    defaultProps: function defaultProps() {
        return {
            embeddedTweetsHeaderText: 'HAPPY TWEETS FROM HAPPY USERS'
        };
    },

    componentDidMount: function componentDidMount() {
        var node = _reactDom2['default'].findDOMNode(this);
        var twitterScript = document.createElement('script');
        twitterScript.src = '//platform.twitter.com/widgets.js';
        twitterScript.charset = 'utf-8';
        twitterScript.async = true;
        node.appendChild(twitterScript);
    },

    render: function render() {
        return _jsx('div', {}, void 0, _jsx('div', {
            className: 'small-12 small-centered small-text-center columns'
        }, void 0, _jsx('h6', {
            className: 'm-marketing-page--subheader-small c-ashen',
            style: { fontSize: 18 }
        }, void 0, this.props.embeddedTweetsHeaderText)), _jsx('div', {
            className: 'small-12 text-center m-marketing-page--embedded-tweets'
        }, void 0, _jsx('div', {
            className: 'm-marketing-page--embedded-tweet'
        }, void 0, _jsx('blockquote', {
            className: 'twitter-tweet',
            lang: 'en'
        }, void 0, _jsx('p', {
            lang: 'en',
            dir: 'ltr'
        }, void 0, 'A few of my favorite things that have up leveled my business into the modern age.', _jsx('a', {
            href: 'https://twitter.com/AcuitySchedulin'
        }, void 0, '@AcuitySchedulin'), ',', _jsx('a', {
            href: 'https://twitter.com/freshbooks'
        }, void 0, '@freshbooks'), ',', _jsx('a', {
            href: 'https://twitter.com/HelloSign'
        }, void 0, '@HelloSign'), ',', _jsx('a', {
            href: 'https://twitter.com/BraidCreative'
        }, void 0, '@BraidCreative')), '— Jolene Park (@JolenePark)', _jsx('a', {
            href: 'https://twitter.com/JolenePark/status/644242654952210432'
        }, void 0, 'September 16, 2015'))), _jsx('div', {
            className: 'm-marketing-page--embedded-tweet'
        }, void 0, _jsx('blockquote', {
            className: 'twitter-tweet',
            lang: 'en'
        }, void 0, _jsx('p', {
            lang: 'en',
            dir: 'ltr'
        }, void 0, _jsx('a', {
            href: 'https://twitter.com/HelloSign'
        }, void 0, '@HelloSign'), 'has finally helped me get my contract game on track! Now I\'ve got your signature.', _jsx('a', {
            href: 'http://t.co/EewBKaXZCX'
        }, void 0, 'http://t.co/EewBKaXZCX'), _jsx('a', {
            href: 'https://twitter.com/hashtag/business?src=hash'
        }, void 0, '#business')), '— Melissa Carter (@wcornercreative)', _jsx('a', {
            href: 'https://twitter.com/wcornercreative/status/638107795896844290'
        }, void 0, 'August 30, 2015'))), _jsx('div', {
            className: 'm-marketing-page--embedded-tweet'
        }, void 0, _jsx('blockquote', {
            className: 'twitter-tweet',
            lang: 'en'
        }, void 0, _jsx('p', {
            lang: 'en',
            dir: 'ltr'
        }, void 0, _jsx('a', {
            href: 'https://twitter.com/HelloSign'
        }, void 0, '@HelloSign'), ' You\'re brilliant.'), '— Gloria Steinberg (@iprookie)', _jsx('a', {
            href: 'https://twitter.com/iprookie/status/641273263092572160'
        }, void 0, 'September 8, 2015'))), _jsx('div', {
            className: 'm-marketing-page--embedded-tweet'
        }, void 0, _jsx('blockquote', {
            className: 'twitter-tweet',
            lang: 'en'
        }, void 0, _jsx('p', {
            lang: 'en',
            dir: 'ltr'
        }, void 0, 'Fast, Secure, and Legally Binding eSignatures for Business', _jsx('a', {
            href: 'https://t.co/yZG4FoIFkR'
        }, void 0, 'https://t.co/yZG4FoIFkR')), '— John Wojewoda (@D_digital_dog)', _jsx('a', {
            href: 'https://twitter.com/D_digital_dog/status/637269988160749568'
        }, void 0, 'August 28, 2015')))));
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/common/embedded-tweets.jsx
 ** module id = 817
 ** module chunks = 0
 **/